/**
 * Zeigt in den Farb-Varianten-Buttons (Warenkorb / Produktseite) das
 * Variantenbild an, das im Shopify Admin bei der jeweiligen Variante
 * hinterlegt ist (z. B. Rotbraun / Grau / Schwarz). Nur das Bild ist
 * sichtbar, der Farbname wird optisch ausgeblendet (bleibt aber fuer
 * Screenreader vorhanden).
 *
 * Rein clientseitig, keine Aenderung an sections/main-product.liquid noetig.
 */
(function () {
  "use strict";

  var STYLE_ID = "variant-swatch-images-style";

  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement("style");
    style.id = STYLE_ID;
    style.textContent =
      ".product-form__input input[type='radio'] + label.vsi-swatch-label {" +
      "display: inline-flex; align-items: center; justify-content: center;" +
      "padding: 0.4rem; }" +
      ".vsi-swatch-image { display: block; width: 4.6rem; height: 4.6rem;" +
      "border-radius: 8px; overflow: hidden; flex-shrink: 0; }" +
      ".vsi-swatch-image img { display: block; width: 100%; height: 100%;" +
      "object-fit: cover; }" +
      ".vsi-swatch-text { position: absolute; width: 1px; height: 1px;" +
      "padding: 0; margin: -1px; overflow: hidden; clip: rect(0,0,0,0);" +
      "white-space: nowrap; border: 0; }";
    style.textContent +=
      ".product-form__input input[type='radio']+label.vsi-catalog-standard{display:inline-flex;flex-direction:column;align-items:center;justify-content:flex-start;vertical-align:top;gap:5px;width:76px;min-height:97px;padding:3px 2px;margin:0 7px 10px 0;border:0!important;border-radius:0!important;background:transparent!important;color:inherit!important;box-shadow:none!important;white-space:normal;font-size:11px;line-height:1.3;text-align:center}" +
      ".product-form__input input[type='radio']+label.vsi-catalog-standard::before,.product-form__input input[type='radio']+label.vsi-catalog-standard::after{display:none}" +
      ".vsi-catalog-standard .vsi-swatch-image{display:block;width:60px;height:60px;border:1px solid #dedbd5;border-radius:50%;background:#fff;padding:4px;box-sizing:border-box}" +
      ".vsi-catalog-standard .vsi-swatch-image img{width:100%;height:100%;object-fit:contain}" +
      ".vsi-catalog-standard .vsi-swatch-text{position:static;width:auto;height:auto;padding:0;margin:0;overflow:visible;clip:auto;white-space:normal;border:0}" +
      ".product-form__input input[type='radio']:checked+label.vsi-catalog-standard .vsi-swatch-image{border:2px solid #9d4b28;box-shadow:0 0 0 2px #e2d1c3}" +
      ".product-form__input input[type='radio']:checked+label.vsi-catalog-standard .vsi-swatch-text{color:#9d4b28;font-weight:700}" +
      ".product-form__input input[type='radio']:focus-visible+label.vsi-catalog-standard .vsi-swatch-image{outline:2px solid currentColor;outline-offset:3px}" +
      "@media(max-width:749px){.product-form__input input[type='radio']+label.vsi-catalog-standard{width:67px;margin-right:4px}}";
    document.head.appendChild(style);
  }

  function getVariantImageSrc(variant) {
    if (!variant) return null;
    if (variant.featured_image && variant.featured_image.src) {
      return variant.featured_image.src;
    }
    if (variant.featured_media && variant.featured_media.preview_image) {
      return variant.featured_media.preview_image.src;
    }
    return null;
  }

  function buildSrcset(src) {
    // Shopify CDN image URLs accept a width param; keep it simple and small.
    if (src.indexOf("?") === -1) {
      return src + "&width=96";
    }
    return src + "&width=96";
  }

  function decorateVariantPicker(root) {
    var script = root.querySelector("script[type='application/json']");
    if (!script) return;

    var variants;
    try {
      variants = JSON.parse(script.textContent);
    } catch (e) {
      return;
    }
    if (!variants || !variants.length) return;

    var standardProducts = ['beuteltasche-siena','businesstasche-padova','umhangetasche-torino','reisetasche-volterra','aktentasche-milano'];
    var productPath = (root.getAttribute("data-url") || "").split("?")[0].replace(/\/$/, "");
    var standardProduct = standardProducts.some(function(handle) { return productPath.endsWith("/products/" + handle); });
    if (standardProduct && root.closest("[data-rv-bag-root]")) return;
    var imageOverrides = {"60765319266638":"https://cdn.shopify.com/s/files/1/0927/8813/0126/files/e7839f02-00af-45bb-8bb9-77e1eaf15b0e_b700475d-9293-431e-b639-5885139f2f49.png?v=1789709935","60765319299406":"https://cdn.shopify.com/s/files/1/0927/8813/0126/files/c59fe66e-2f12-498d-8837-77b574dccefd_7b14f63a-2fc3-4b4d-b66a-29adea62c161.png?v=1789709833","60765319332174":"https://cdn.shopify.com/s/files/1/0927/8813/0126/files/0b6f225f-9e8c-4946-8f6e-d720e93021c0_caa9968e-a572-40c0-ac19-649bdb324449.png?v=1789709898","60765315400014":"https://cdn.shopify.com/s/files/1/0927/8813/0126/files/22_cdba8fde-cb9b-4a40-9812-176030e63025.jpg?v=1789216201","60765313925454":"https://cdn.shopify.com/s/files/1/0927/8813/0126/files/rv-torino-schwarz-farbvorschau.jpg?v=1793013273"};
    var replacements = {};
    if (standardProduct) {
      variants.forEach(function(variant) {
        var replacement = imageOverrides[String(variant.id)];
        if (!replacement) return;
        var oldSource = getVariantImageSrc(variant);
        if (oldSource) replacements[oldSource.split("/").pop().split("?")[0]] = replacement;
        variant.featured_image = Object.assign({}, variant.featured_image, {src: replacement});
        if (variant.featured_media) {
          variant.featured_media = Object.assign({}, variant.featured_media, {src: replacement,
            preview_image: Object.assign({}, variant.featured_media.preview_image, {src: replacement})});
        }
      });
      script.textContent = JSON.stringify(variants);
      root.variantData = variants;
      var section = root.closest("section");
      var pictures = section ? Array.from(section.querySelectorAll("img")) : [];
      var modal = document.getElementById("ProductModal-" + root.dataset.section);
      if (modal) pictures = pictures.concat(Array.from(modal.querySelectorAll("img")));
      pictures.forEach(function(img) {
        var oldSource = img.getAttribute("src") || "";
        var replacement = replacements[oldSource.split("/").pop().split("?")[0]];
        if (replacement) {
          img.removeAttribute("srcset");
          img.src = replacement;
        }
      });
    }
    var fieldsets = root.querySelectorAll("fieldset.js.product-form__input");
    if (!fieldsets.length) return;

    fieldsets.forEach(function (fieldset, fieldsetIndex) {
      var optionPosition = fieldsetIndex + 1; // option1 / option2 / option3
      var inputs = fieldset.querySelectorAll("input[type='radio']");

      inputs.forEach(function (input) {
        var value = input.value;
        var legend = fieldset.querySelector("legend");
        var colorOption = legend && /farb|colou?r/i.test(legend.textContent);
        var label = fieldset.querySelector("label[for='" + input.id + "']");
        if (!label) return;

        var match = null;
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          var optionValue =
            optionPosition === 1
              ? v.option1
              : optionPosition === 2
              ? v.option2
              : optionPosition === 3
              ? v.option3
              : null;
          if (optionValue === value) {
            var src = getVariantImageSrc(v);
            if (src) {
              match = src;
              break;
            }
          }
        }

        if (match && standardProduct && colorOption) label.classList.add("vsi-catalog-standard");
        if (match && !label.querySelector(".vsi-swatch-image")) {
          label.classList.add("vsi-swatch-label");

          // Vorhandenen Text (Farbname) in einen visuell versteckten Span
          // verschieben, damit er fuer Screenreader erhalten bleibt, aber
          // nicht mehr angezeigt wird - nur das Bild soll sichtbar sein.
          var textSpan = document.createElement("span");
          textSpan.className = "vsi-swatch-text";
          while (label.firstChild) {
            textSpan.appendChild(label.firstChild);
          }

          var imgSpan = document.createElement("span");
          imgSpan.className = "vsi-swatch-image";
          var img = document.createElement("img");
          img.src = buildSrcset(match);
          img.loading = "lazy";
          img.alt = value;
          imgSpan.appendChild(img);

          label.appendChild(imgSpan);
          label.appendChild(textSpan);
        }
      });
    });
  }

  function run() {
    injectStyle();
    var pickers = document.querySelectorAll("variant-radios");
    pickers.forEach(function (picker) {
      decorateVariantPicker(picker);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }
})();
